:host {
  --aha-loading-dots--dot-size: 0.958ex;
  --aha-loading-dots--initial-scale: 0.35;
  --aha-loading-dots--animation-duration: 0.8s;
}
#dots {
  display: inline-flex;
  gap: 0.2ex;
  top: calc(-1 * (var(--aha-loading-dots--dot-size) / 6));
  position: relative;
}
.dot {
  display: inline-block;
  aspect-ratio: 1;
  width: var(--aha-loading-dots--dot-size);
  position: relative;
}
.dot::before {
  content: '';
  transform-origin: center;
  scale: var(--aha-loading-dots--initial-scale);
  position: absolute;
  inset: 0;
  background: currentColor;
  border-radius: 50%;
  animation: var(--aha-loading-dots--animation-duration) linear infinite both paused scaleDot;
}
#dot-2::before {
  animation-delay: calc(var(--aha-loading-dots--animation-duration) * 0.2);
}
#dot-3::before {
  animation-delay: calc(var(--aha-loading-dots--animation-duration) * 0.4);
}

:host(.visible) .dot::before {
  animation-play-state: running;
}

@keyframes scaleDot {
  0% {
    scale: var(--aha-loading-dots--initial-scale);
  }
  20% {
    scale: 1;
  }
  25% {
    scale: 1;
  }
  50% {
    scale: var(--aha-loading-dots--initial-scale);
  }
}
